import React from 'react';
import { BookOpenIcon, FilterIcon, CalculatorIcon, ShieldIcon, CheckSquareIcon, CheckIcon, LanguagesIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-6 h-6 text-brand-gold" data-id="element-285" />,
    title: 'El Método Anti-Tipster (PDF)',
    description: 'Valor: $97\nConstruye un criterio que te permita detectar apuestas con ventaja…'
  }, {
    icon: <FilterIcon className="w-6 h-6 text-brand-gold" data-id="element-286" />,
    title: 'El Protocolo de Confirmación de 5 Pasos',
    description: 'Valor: $147\nEl filtro exacto que evita apuestas impulsivas…'
  }, {
    icon: <CalculatorIcon className="w-6 h-6 text-brand-gold" data-id="element-287" />,
    title: 'Calculadora de Probabilidad Implícita',
    description: 'Valor: $47 Para saber si una cuota es un regalo o una trampa.'
  }, {
    icon: <ShieldIcon className="w-6 h-6 text-brand-gold" data-id="element-288" />,
    title: 'Guía de Gestión de Banca',
    description: 'Valor: $197 Cómo dividir tu capital en unidades para que nunca vuelvas a quemar una cuenta.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-brand-gold" data-id="element-289" />,
    title: 'Checklist Pre-Partido',
    description: 'Valor: $27 La lista de verificación que usan los profesionales antes de operar.'
  }, {
    icon: <LanguagesIcon className="w-6 h-6 text-brand-gold" data-id="element-290" />,
    title: 'ENTIENDE APUESTAS (Nomenclatura)',
    description: 'Valor: $97 Domina el lenguaje del mercado y deja de tomar decisiones en un idioma que no hablas.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-291">
      
    </section>;
}